if (!customElements.get("banner-carrousel")) {
  customElements.define(
    "banner-carrousel",
    class BannerCarrousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (typeof Swiper === "undefined") return;

        const sliderEl = this.querySelector(".banner-carrousel__swiper");
        if (!sliderEl) return;

        const slides = this.querySelectorAll(".swiper-slide");
        if (slides.length === 0) return;

        const delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
        const speed = parseInt(this.dataset.transitionSpeed, 10) || 600;
        const hasMultipleSlides = slides.length > 1;
        const autoplayEnabled = hasMultipleSlides && this.dataset.designMode !== "true";

        this.swiper = new Swiper(sliderEl, {
          direction: "horizontal",
          loop: hasMultipleSlides,
          speed: speed,
          slidesPerView: 1,
          spaceBetween: 0,
          a11y: {
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
          },
          autoplay: autoplayEnabled
            ? {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
          navigation: hasMultipleSlides
            ? {
                nextEl: this.querySelector(".swiper-button-next"),
                prevEl: this.querySelector(".swiper-button-prev"),
              }
            : false,
        });
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    },
  );
}
